"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 14. 12. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var index_1 = require("../../core/utils/index");

var PricingType_1 = require("../model/PricingType");

var ReleaseType_1 = require("../model/ReleaseType");

var ReleaseWorkflowType_1 = require("../model/ReleaseWorkflowType");
/**
 * Parsers for release attributes.
 * @author Radek Beran
 */


var ReleaseParsers =
/*#__PURE__*/
function () {
  function ReleaseParsers() {
    _classCallCheck(this, ReleaseParsers);
  }

  _createClass(ReleaseParsers, null, [{
    key: "parseReleaseType",
    value: function parseReleaseType(queryParsed) {
      var releaseTypeStr = queryParsed['releaseType'];

      if (index_1.Utils.isString(releaseTypeStr)) {
        return ReleaseType_1.ReleaseType[releaseTypeStr];
      }

      return null;
    }
  }, {
    key: "parseReleaseWorkflowType",
    value: function parseReleaseWorkflowType(queryParsed) {
      var workflowTypeStr = queryParsed['workflowType'];

      if (index_1.Utils.isString(workflowTypeStr)) {
        return ReleaseWorkflowType_1.ReleaseWorkflowType[workflowTypeStr];
      }

      return null;
    }
  }, {
    key: "parsePriceListType",
    value: function parsePriceListType(queryParsed) {
      var priceListType = queryParsed['priceListType'];

      if (index_1.Utils.isString(priceListType)) {
        return priceListType;
      }

      return null;
    }
  }, {
    key: "parsePricingType",
    value: function parsePricingType(queryParsed) {
      var pricingTypeStr = queryParsed['pricingType'];

      if (index_1.Utils.isString(pricingTypeStr)) {
        return PricingType_1.PricingType[pricingTypeStr];
      }

      return null;
    }
  }]);

  return ReleaseParsers;
}();

exports.ReleaseParsers = ReleaseParsers;